import _ from 'lodash';
import { CompositeColumn } from '@/types';
import getCompositeColumnsMapping from './getCompositeColumnsMapping';

function getAllCompositeColumns(): CompositeColumn[] {
  return _.values(getCompositeColumnsMapping());
}

export default getAllCompositeColumns;
